import { QueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
			retry: (failureCount, error) => {
				if ((error as AxiosError)?.response?.status === 500) return false;
				return failureCount < 1;
			},
			staleTime: 1000 * 60,
		},
	},
});
